import antdThemeOverrides from './antd-theme-green';
import createBreakpoints from './breakpoints';
import colorPool from './colorPool';

// We define and use our own theme such that we will have less dependency to the
// underlying UI library that we use.
const theme = {
  colors: {
    primary: antdThemeOverrides['primary-color'],
    primaryLight: '#40a9ff',
    accent: '#000000',
    accentLight: '#000000',

    // Dark text.
    textPrimaryDark: 'rgba(0, 0, 0, 0.87)',
    textSecondaryDark: 'rgba(0, 0, 0, 0.54)', // #8a000000
    // textSecondaryDark: 'rgba(0, 0, 0, 0.60)',
    textSecondaryLightenedDark: 'rgba(0, 0, 0, 0.44)', // #70000000
    textDisabledDark: 'rgba(0, 0, 0, 0.34)', // #57000000
    textHintDark: 'rgba(0, 0, 0, 0.34)', // #57000000
    textIconDark: 'rgba(0, 0, 0, 0.34)', // #57000000

    // Light text.
    textPrimaryLight: 'rgba(255, 255, 255, 1)',
    textSecondaryLight: 'rgba(255, 255, 255, 0.7)',
    textDisabledLight: 'rgba(255, 255, 255, 0.5)',
    textHintLight: 'rgba(255, 255, 255, 0.5)',
    textIconLight: 'rgba(255, 255, 255, 0.5)',
    textDividerLight: 'rgba(255, 255, 255, 0.12)',
    textLightDividerLight: 'rgba(255, 255, 255, 0.075)',

    // Other text.
    textPrimaryColored: antdThemeOverrides['primary-color'],
    textAccentColored: '#000000',

    // Component colors
    controlBorder: '#d9d9d9',
    controlBorderLightened: '#eaeaea',
    grayBackground: '#fafafa',
    hoverBackground: '#fafafa',
    pressBackground: '#eaeaea',

    containerBackground: '#ffffff',
    containerGrayBackground: '#f6f6f6',
    containerGray2Background: '#f0f0f0', // Grayer color.
    containerDarkTransparentBackground: '#000000a0',
    containerQuoteBackground: '#f4f4f4',
    ...colorPool,
  },

  breakpoints: createBreakpoints(),

  dimensions: {
    max_content: window.innerWidth >= 1440 ? '1300px' : '1170px',
    match_parent: '100%',
    match_parent_with_margin: 'auto',
    wrap_content: 'auto',
  },
};

export default ({ ...theme });
